var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPastoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.077,
    height: 53.811,
    viewBox: "0 0 59.077 53.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2984",
    "data-name": "Group 2984",
    transform: "translate(-253.352 -294.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2985",
    "data-name": "Group 2985",
    transform: "translate(275.946 315.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2984-2",
    "data-name": "Group 2984",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3873",
    "data-name": "Path 3873",
    d: "M532.859,550.633s5.316-4.826,6.529-5.909c2.315-2.068-.388-4.275-2-3.9-2.257.521-4.891,2.235-7.663,3.786,0,0-10.371,3.045-13.9,8.488-5.046,7.787,5.587,14.188,5.587,14.188a48.323,48.323,0,0,1,13.316-9.5,78.211,78.211,0,0,1,8.248-3.464c2.448-.581,3.92-5.565,4.594-8.8.629-3.015,2.389-9.578-.2-9.578-2.36,0-3.278,2.427-3.635,4.314a31.423,31.423,0,0,1-1.619,5.708l-.143.362-6.54,1.972",
    transform: "translate(-514.464 -535.946)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3874",
    "data-name": "Path 3874",
    d: "M277.305,332.719c3.528-5.444,13.9-8.488,13.9-8.488,2.773-1.551,5.406-3.265,7.663-3.786,1.616-.373,4.319,1.835,2,3.9-1.213,1.083-3.961,3.58-3.961,3.58l6.54-1.972.143-.362a31.408,31.408,0,0,0,1.619-5.708c.357-1.887,1.275-4.314,3.635-4.314.707,0,1.088.49,1.259,1.26a16.9,16.9,0,0,0,.792-5.614h0c.008-.192.015-.385.015-.579A14.766,14.766,0,0,0,296.236,296.1a15.105,15.105,0,0,0-13.344,8.674h0a15.105,15.105,0,0,0-13.344-8.674,14.766,14.766,0,0,0-14.674,14.542c0,.194.007.387.015.579h0s-.828,9.253,9.469,19.356c3.853,3.86,8.083,7.564,14.262,12.658C276.381,340.628,274.615,336.871,277.305,332.719Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastoral);
export default __webpack_public_path__ + "static/media/pastoral.36e3b23542fcdb10e0ae8f80531c3e6f.svg";
export { ForwardRef as ReactComponent };